<template>
    <div class="Table">
        <table>
            <thead>
                <slot name="head"></slot>
            </thead>

            <tbody>
                <slot></slot>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'Table',
};
</script>

<style lang="scss">
@import 'globals.scss';

.Table {
    width: 100%;
    box-shadow: $shadow-soft;
    border-radius: $border-radius;
    background-color: $bg-color-1;

    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
    }

    thead {
        font-weight: $font-weight-bold;

        th {
            font-size: 15px;
            padding: 20px $grid-gutter-width;
            white-space: nowrap;
            text-align: left;
        }
    }

    tbody {
        border-top: 1px solid $divider-color;

        tr:not(:last-child) {
            border-bottom: 1px solid $divider-color;
        }

        td {
            max-width: 40px;
            padding: 10px $grid-gutter-width;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    th,
    td {
        &:first-child {
            padding-left: 20px;
        }

        &:last-child {
            padding-right: 20px;
            text-align: right;
        }
    }

    &.actions {
        td:last-child {
            overflow: visible;
        }
    }
}
</style>
